<div class="hpanel margin-right-5 hred">
  <div class="panel-body border-radius-top-left-right-6">
    <!-- <span class="label label-danger pull-right" (ngclick)="deactivate()">Deactivate</span> -->
    <button class="btn btn-danger pull-right" (click)="deactivate()">
      Deactivate
    </button>
    <!-- (click)="deactivate() -->

    <div class="row">
      <div class="col-sm-8">
        <h4 style="word-break: break-word;">
          <a > Deactivate {{ BusinessData?.businessName }}</a>
        </h4>

        <div class="row">
          <!-- <div class="col-sm-3">
                        <div class="project-label">EMPLOYEES</div>
                        <small *ngIf="BusinessData?.followersCnt > 0">{{BusinessData?.employeesCnt}}</small>
                        <small *ngIf="BusinessData?.followersCnt < 1">No EMPLOYEES</small>
                    </div>
                    <div class="col-sm-3">
                        <div class="project-label">FOLLOWERS</div>
                        <small *ngIf="BusinessData?.followersCnt > 1">{{BusinessData?.followersCnt}}</small>
                        <small *ngIf="BusinessData?.followersCnt < 0">No followers</small>
                    </div> -->
          <!-- <div class="col-sm-3">
                        <div class="project-label">COMMUNITY</div>
                        <small>26.02.2015</small>
                    </div>
                    <div class="col-sm-3">
                        <div class="project-label">POST JOBS</div>
                        <small>26.02.2015</small>
                    </div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="panel-footer">
        Additional information about project in footer
    </div> -->
</div>
